<template>
  <div class="userlist">
    <!-- <div class="infinite-list-wrapper" style="overflow:auto">
      <ul class="list" v-infinite-scroll="load" infinite-scroll-disabled="disabled">
        <li v-for="(i,index) in count" :key="index" class="list-item">{{ i }}</li>
      </ul>
      <p v-if="loading">加载中...</p>
      <p v-if="noMore">没有更多了</p>
    </div> -->
    <div class="session_list" style="overflow: auto">
      <li v-for="(item, index) in userList[type]" :key="item.conversationId" @click="select2(item, index)">
        <div class="session_list_item" :class="currentConversationId === item.conversationId ?'active':''">
          <div class="item_body item_main">
            <div class="name">{{ handleConversationName(item) }}</div>
            <span class="time">{{new Date(item?.lastMessage?.time).format("MM/dd/hh:mm")}}</span>
          </div>
          <div class="item_body item_main ">
            <div class="last_msg_body">{{ item.lastMessage && handleLastMsgContent(item.lastMessage) }} </div>
            <div class="unReadNum_box" v-if="item.unReadCount >= 1">
              <div class="unReadNum_count" v-text="item.unReadCount >= 99 ? '99+' : item.unReadCount"></div>
            </div>
          </div>
        </div>
      </li>
    </div>
  </div>
</template>

<script>
import "./index.less";
import { mapActions, mapGetters } from "vuex";
import _ from "lodash";
import infiniteScroll from "vue-infinite-scroll";
export default {
  directives: {
    infiniteScroll,
  },
  data () {
    return {
      count: 100,
      loading: false,

      activedKey: {
        contact: "",
        group: "",
        chatroom: "",
      },
      headPortraitImg: require("@/assets/headPortrait.jpeg"),
      showFirendMenus: false,
      firendMenus: [
        {
          name: "加入黑名单",
          id: "1",
          icon: "add-o",
        },
        {
          name: "删除好友",
          id: "2",
          icon: "delete",
        },
      ],
      message: "",
      isHttps: window.location.protocol === "https:",
      status: {
        sending: "发送中",
        sent: "已发送",
        read: "已读",
      },
      isCollapse: true,
      unRead: "",
      dataFlag: false,
      pushConfigData: [],
    };
  },
  beforeMount () {
    this.onGetContactUserList();
  },
  mounted () {
    // 取到黑名单列表值将黑名单匹配用户列表进行筛选
    let blackList = this.$store.state.friendModule.blackList;
    this.$store.commit("changeUserList", blackList);
    if (this.userList.contact.length && !this.activedKey[this.type]) {
      this.select2(this.userList.contact[0]);
    }
  },
  updated () {
    this.scollBottom();
  },
  watch: {
    contact: {
      handler (val) {
        // this.getAllFriendsStatus()
        this.dataFlag = false;

        const params = {
          usernames: [],
        };
        val.forEach((item) => {
          params.usernames.push(item.name);
        });
        // params.usernames.length && this.subFriendStatus(params).then(res => {
        // 	console.log(res, this.contact, '333333333333333333')
        // 	let tempArr = []
        // 	val.forEach((item) => {
        // 		res.result.forEach(val => {
        // 			if(item.name === val.uid){
        // 				tempArr.push(val.uid)
        // 				item.presence = val
        // 			}
        // 		})
        // 	})
        // 	console.log(tempArr, 'tempArr')
        // 	val.forEach(item => {
        // 		if (!tempArr.includes(item.name)) {
        // 			item.presence = {
        // 				uid: item.name,
        // 				ext: 'Offline',
        // 				status: [],
        // 				expiry: new Date().getTime(),
        // 				last_time: new Date().getTime()
        // 			}
        // 		}
        // 	})

        // 	console.log(this.userList, 'this.userList===this.userList')
        // 	setTimeout(() => {
        // 		this.dataFlag = true
        // 	}, 500)
        // })
      },
      deep: true,
    },
    group: {
      handler (val) { },
      deep: true,
    },
    chatroom: {
      handler (val) { },
      deep: true,
    },
    pushConfig: {
      handler (newVal, oldVal) {
        this.pushConfigData = newVal;
      },
      deep: true,
    },
  },
  computed: {
    noMore () {
      return this.count >= 200;
    },
    disabled () {
      return this.loading || this.noMore;
    },
    ...mapGetters({
      currentConversationId: 'currentConversationId',
      contact: "onGetContactUserList",
      group: "onGetGroupUserList",
      chatroom: "onGetChatroomUserList",
      msgList: "onGetCurrentChatObjMsg",
      pushConfig: "onPushConfig",
    }),
    userList () {
      if (this.contact.length && !this.activedKey[this.type]) {
        this.select2(this.contact[0]);
      }
      return {
        contact: this.contact.filter((item) => {
          if (item && !this.blackList.includes(item.name)) {
            return item;
          }
        }),
        group: this.group,
        chatroom: this.chatroom,
      };
    },
    blackList () {
      return Object.keys(this.$store.state.friendModule.blackList);
    },
    chatList () {
      return this.$store.state.chat.msgList;
    },
  },

  props: [
    "type", // 聊天类型 contact, group, chatroom
    "username", // 选中的聊天对象
    "select",
    "card",
    "broken",
  ],
  methods: {
    ...mapActions([
      "onGetContactUserList",
      "onGetGroupUserList",
      "onGetChatroomUserList",
      "onGetCurrentChatObjMsg",
      "onSendText",
      "onCallVideo",
      "onCallVoice",
      "getGroupMembers",
      "getHistoryMessage",
      "onAddBlack",
      "onDelteFirend",
      "onGetGroupinfo",
      "onGetGroupBlack",
      "onGetFirendBlack",
      "onGetAllFriendsInfo",
      "getAllFriendsStatus",
      "getSubPresence",
      "subFriendStatus",
    ]),
    handleLastMsgContent (item) {
      return item.msg;
    },
    handleConversationName (item) {
      return item.tbNickName;
    },
    load () {
      this.loading = true;
      setTimeout(() => {
        this.count += 2;
        this.loading = false;
      }, 2000);
    },

    handleOpen (key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose (key, keyPath) {
      // console.log(key, keyPath);
    },
    getKey (item) {
      let key = "";
      switch (this.type) {
        case "contact":
          key = item.name;
          break;
        case "group":
          key = item.groupid;
          break;
        case "chatroom":
          key = item.id;
          break;
        default:
          break;
      }
      return key;
    },
    alertPersaonCard (i) {
      if (i.friendDetail) {
        this.card.getOthersUserInfo(i);
      }
    },
    getUnreadNum (item) {
      const name = "contact";
      const chatList = this.chatList[name];
      let userId = item.name;
      const currentMsgs = chatList[userId] || [];
      let unReadNum = 0;
      currentMsgs.forEach((msg) => {
        let isRenderNum =
          msg.chatType === "group"
            ? this.pushConfigData.includes(msg.chatId)
            : this.pushConfigData.includes(msg.from);
        if (
          msg.status !== "read" &&
          msg.status !== "recall" &&
          !msg.bySelf &&
          !isRenderNum
        ) {
          unReadNum++;
        }
      });
      return unReadNum;
    },
    select2 (item) {
      this.select(item);

    },
    readMsg (item) {
      let option = {
        type: "channel",
        chatType: "singleChat",
        to: item.conversationId,
      };
      let msg = WebIM.message.create(option);
      WebIM.conn.send(msg).then(() => {
        this.$store.commit('clearConversationUnreadCount', item.conversationId)
      });
    },
    changeMenus () {
      if (this.type === "contact") {
        this.$data.showFirendMenus = !this.$data.showFirendMenus;
      } else if (this.type === "group") {
        this.$refs.groupInfoModel.chengeInfoModel();
        this.getGroupInfo();
      }
    },

    getGroupInfo () {
      this.onGetGroupinfo({
        select_id: this.$data.activedKey[this.type].groupid,
      });
    },
    callVideo () {
      if (this.type == "contact") {
        this.$refs.emediaModal.showEmediaModal();
        this.$refs.emediaModal.showCallerWait(
          this.$data.activedKey[this.type].name
        );
        const videoSetting = JSON.parse(localStorage.getItem("videoSetting"));
        const recMerge = (videoSetting && videoSetting.recMerge) || false;
        const rec = (videoSetting && videoSetting.rec) || false;
        this.onCallVideo({
          chatType: this.type,
          to: this.$data.activedKey[this.type].name,
          rec,
          recMerge,
        });
      } else if (this.type == "group") {
        this.getGroupMembers(this.$data.activedKey[this.type].groupid);
        this.$refs.addAvMembertModal.show();
      }
    },
    callVoice () {
      this.$refs.emediaModal.showEmediaModal();
      this.$refs.emediaModal.showCallerWait(
        this.$data.activedKey[this.type].name
      );
      const videoSetting = JSON.parse(localStorage.getItem("videoSetting"));
      const recMerge = (videoSetting && videoSetting.recMerge) || false;
      const rec = (videoSetting && videoSetting.rec) || false;
      this.onCallVoice({
        chatType: this.type,
        to: this.$data.activedKey[this.type].name,
        rec,
        recMerge,
      });
    },
    readablizeBytes (value) {
      let s = ["Bytes", "KB", "MB", "GB", "TB", "PB"];
      let e = Math.floor(Math.log(value) / Math.log(1024));
      return (value / Math.pow(1024, Math.floor(e))).toFixed(2) + " " + s[e];
    },

    // TODO 可以抽离到utils
    renderTime (time) {
      // const nowStr = new Date();
      // const localStr = time ? new Date(time) : nowStr;
      // const localMoment = moment(localStr);
      // const localFormat = localMoment.format("MM-DD hh:mm A");
      // return localFormat;
      var t = new Date(parseInt(time));
      var Y = t.getFullYear();
      var M =
        t.getMonth() + 1 < 10 ? "0" + (t.getMonth() + 1) : t.getMonth() + 1;
      var D = t.getDate() < 10 ? "0" + t.getDate() : t.getDate();
      var H = t.getHours() < 10 ? "0" + t.getHours() : t.getHours();
      var F = t.getMinutes() < 10 ? "0" + t.getMinutes() : t.getMinutes();
      var S = t.getSeconds() < 10 ? "0" + t.getSeconds() : t.getSeconds();
      return `${M}-${D} ${H}:${F}`;
    },
    getLastMsg (item) {
      const name = "contact";
      const chatList = this.chatList[name];
      let userId = "";
      if (name == "contact") {
        userId = item.name;
      } else if (name == "group") {
        userId = item.groupid;
      } else {
        userId = item.id;
      }
      const currentMsgs = chatList[userId] || [];
      let lastMsg = "";
      let lastType =
        currentMsgs.length && currentMsgs[currentMsgs.length - 1].type;
      if (currentMsgs.length) {
        if (lastType === "img") {
          lastMsg = "[image]";
        } else if (lastType === "file") {
          lastMsg = currentMsgs[currentMsgs.length - 1].filename;
        } else if (lastType === "audio") {
          lastMsg = "[audio]";
        } else if (lastType === "vidio") {
          lastMsg = "[vidio]";
        } else {
          lastMsg = currentMsgs[currentMsgs.length - 1].msg;
        }
      }
      const msgTime = currentMsgs.length
        ? this.renderTime(currentMsgs[currentMsgs.length - 1].time)
        : "";
      return {
        lastMsg,
        msgTime,
      };
    },
    scollBottom () {
      setTimeout(() => {
        const dom = this.$refs.msgContent;
        if (!dom) return;
        dom.scrollTop = dom.scrollHeight;
      }, 0);
    },
    getUserOnlineStatus (val) {
      const { ext } = val;
      console.log(ext === "", "getUserOnlineStatus");
      switch (ext) {
        case "Offline":
          return require("@/assets/Offline.png");
        case "Online":
          return require("@/assets/Online.png");
        case "":
          return require("@/assets/Online.png");
        case "Busy":
          return require("@/assets/Busy.png");
        case "Do not Disturb":
          return require("@/assets/Do_not_Disturb.png");
        case "Leave":
          return require("@/assets/leave.png");
        default:
          return require("@/assets/custom.png");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.session_list {
  border-right: 1px solid #d5d5d5;
  box-sizing: border-box;
  position: relative;
  background: #ffffff;
  height: 100%;
  padding: 0;
  margin: 0;
}

.offline_hint {
  width: 100%;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #f35f81;
  background: #fce7e8;
  font-size: 7px;

  .plaint_icon {
    display: inline-block;
    width: 15px;
    height: 15px;
    color: #e5e5e5;
    text-align: center;
    line-height: 15px;
    font-size: 7px;
    font-weight: bold;
    background: #e6686e;
    border-radius: 50%;
  }
}

.session_list .session_list_item {
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
  background: #f7f7f7;
  box-sizing: border-box;
  color: var(--el-color-primary);
  border-bottom: 1px solid var(--el-border-color);
  cursor: pointer;
  &.active {
    background: #dedede;
    &:hover {
      background: #d3d3d3;
    }
  }
  &:hover {
    background: #eaeaea;
  }

  .item_body {
    display: flex;
    height: 100%;
  }

  .item_left {
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-left: 14px;
    margin-right: 10px;
  }

  .item_main {
    box-sizing: border-box;
    padding: 0 10px;
    width: 230px;
    max-width: 230px;
    justify-content: space-between;
    align-items: center;

    .name {
      min-width: 56px;
      max-width: 165px;
      height: 17px;
      font-weight: 400;
      font-size: 14px;
      line-height: 1;
      /* identical to box height */
      color: #333333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: left;
    }
    .time {
      font-size: 10px;
      font-weight: 400;
      font-size: 10px;
      line-height: 1;
      letter-spacing: 0.25px;
      color: #a3a3a3;
    }
    .last_msg_body {
      max-width: 185px;
      height: 20px;
      font-weight: 400;
      font-size: 12px;
      line-height: 20px;
      letter-spacing: 0.3px;
      color: #a3a3a3;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .last_msg_body_mention {
      font-size: 12px;
      line-height: 17px;
      font-weight: bold;
      color: red;
    }
    .unReadNum_box {
      height: 20px;
      .unReadNum_count {
        display: inline-block;
        min-width: 20px;
        height: 20px;
        padding: 0 6px;
        color: #fff;
        font-weight: normal;
        font-size: 12px;
        line-height: 20px;
        white-space: nowrap;
        text-align: center;
        background: #f5222d;
        border-radius: 10px;
        box-sizing: border-box;
      }
    }
  }
}

.session_list_item_active {
  background: #d2d2d2;
}

.session_list .session_list_item + .list_item {
  margin-top: 10px;
}

.session_list_delete {
  cursor: pointer;
  transition: all 0.5s;

  &:hover {
    background: #e1e1e1;
  }
}
</style>
